import { APIClient } from "../setup/axios/ApiHelper";

const api = new APIClient();

const ProductAPI = {
  getList: (params: any) => api.get('product/list', params),
}

export default ProductAPI